import React, { useState } from 'react';
import styled from 'styled-components';
import { LinkFarmToggle } from '@zocdoc-frontend-common/components-footer/LinkFarmToggle';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { white } from '@zocdoc-mezzanine/foundations-colors';
import { CityLinks } from './CityLinks';

/**
 * Accordion Links.  Labeled with Specialty.  When expanded, show links to cities.
 * @param {Object} topListingPages -- Object containing array of specialties and array of cities
 * @param {function} renderFooterLink -- Callback to function defined in MobileMenu.js
 * @param {boolean} __forceOpenListingPages -- Set to true for storybook testing
 * @param {string} hostOverride
 * @returns {JSX.Element}
 */
export const SpecialtyAccordion = ({
    topListingPages,
    renderFooterLink,
    __forceOpenListingPages,
    hostOverride = '',
}) => {
    const [isSpecialtyExpanded, setIsSpecialtyExpanded] = useState(
        topListingPages.specialties.reduce((expanded, specialty) => {
            expanded[specialty.name] = __forceOpenListingPages;
            return expanded;
        }, {})
    );
    const toggleSpecialty = (specialty) => {
        setIsSpecialtyExpanded((previousSpecialties) => ({
            ...previousSpecialties,
            [specialty]: !previousSpecialties[specialty],
        }));
    };

    return (
        <Section data-test="mobile-menu-top-listing-pages-links">
            <SectionHeader>Browse Doctors Near You</SectionHeader>
            {topListingPages.specialties.map((specialty) => {
                const expanded = isSpecialtyExpanded[specialty.name];
                return (
                    <SpecialtyLinks
                        key={specialty.name}
                        data-test={`mobile-menu-top-${specialty.name}-links`}
                    >
                        <LinkFarmToggle
                            toggleText={specialty.name}
                            toggleState={expanded}
                            onToggleClick={() => {
                                toggleSpecialty(specialty.name);
                            }}
                        />
                        {expanded && (
                            <CityLinks
                                cities={topListingPages.cities}
                                renderFooterLink={renderFooterLink}
                                specialty={specialty}
                                hostOverride={hostOverride}
                            />
                        )}
                    </SpecialtyLinks>
                );
            })}
        </Section>
    );
};

const SpecialtyLinks = styled.div`
    display: flex;
    flex-direction: column;
`;
const Section = styled.div`
    padding-bottom: 16px;
`;

const SectionHeader = styled.div`
    color: ${white};
    display: inline-block;
    padding: 0 16px;
    font: 15px/2.6 ${FontFamily.SharpSansBold};
`;
